import React from 'react'
import { Carousel } from 'src/components/Common/Carousel'
import { settings } from 'src/carousels/lessons.carousel'
import { Card } from 'src/components/Common/Card'
import {Lesson, Lessons} from "src/service/api/api.types";

type Props = Lessons & { linkType: 'course' | 'lesson' | 'news', marginLeft?: number }

export function Modules({ lessons, linkType, marginLeft }: Props) {
  return (
    <>
      <Carousel<Lesson>
        items={lessons}
        ItemTemplate={Card}
        settings={settings}
        preset="secondary"
        linkType={linkType}
        marginLeft={marginLeft}
      />
    </>
  )
}
